import React from 'react'
import { ClientsList } from './list/page'

export const ClientsPage = (): JSX.Element => {
  return <ClientsList></ClientsList>
}
